// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3a09l","sendOtp":"AuthorizeToLogin_sendOtp__3gNRN"};